import { render } from "./Scholar.vue?vue&type=template&id=593e3be3&scoped=true"
import script from "./Scholar.vue?vue&type=script&lang=js"
export * from "./Scholar.vue?vue&type=script&lang=js"

import "./Scholar.vue?vue&type=style&index=0&id=593e3be3&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e3be3"]])

export default __exports__